import { getBridgeEndpoint } from '../../services/bridgeEndpoint';
import { resolveBridgeUrl } from './bridgeUrlPolicy';

export function getBridgeUrl(): string {
    return resolveBridgeUrl(getBridgeEndpoint(), import.meta.env.VITE_BRIDGE_URL);
}
